/* Comment box behaviour. Markup and styles: snippets/bnb-comment-box.liquid.

   The form submits the normal way, not in the background. The store has Shopify's spam
   protection on, and Shopify's own script watches every contact form on the page: on a normal
   submit it adds an hCaptcha token first, and Shopify's /contact endpoint rejects any post
   without one (HTTP 400). A background fetch skipped that step, so every message failed. That
   version is kept as bnb-comment-box.v1-background-submit.js in the drafts folder, for the record.

   After a normal submit Shopify reloads the same page with ?contact_posted=true#BnbCommentForm,
   and the snippet renders a thank you line inside the form. This script reopens the box to
   show it, closes it a few seconds later, and strips the query and hash from the address bar
   so a refresh does not show the thank you again. */
(function () {
  var btn = document.querySelector('.bnb-cb-btn');
  var box = document.getElementById('BnbCommentBox');
  if (!btn || !box || window.__bnbCommentBox) return;
  window.__bnbCommentBox = true;
  var form = box.querySelector('form');
  var body = form.querySelector('textarea');
  var send = form.querySelector('.bnb-cb-send');
  var status = form.querySelector('[data-bnb-status]');
  var closeBtn = box.querySelector('.bnb-cb-x');
  var timer;

  function say(text, kind) { status.textContent = text; status.className = 'bnb-cb-msg ' + kind; status.hidden = false; }
  function open() {
    box.hidden = false; btn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { body.focus(); }, 30);
  }
  function close(returnFocus) {
    box.hidden = true; btn.setAttribute('aria-expanded', 'false'); clearTimeout(timer);
    if (returnFocus !== false) btn.focus();
  }

  btn.addEventListener('click', function () { if (box.hidden) open(); else close(); });
  closeBtn.addEventListener('click', function () { close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
  document.addEventListener('pointerdown', function (e) {
    if (!box.hidden && !box.contains(e.target) && !btn.contains(e.target)) close(false);
  });

  form.addEventListener('submit', function (e) {
    if (!body.value.trim()) {
      e.preventDefault();
      say('Write a few words first, then press Send.', 'bad'); body.focus();
      return;
    }
    // Let the submit carry on untouched, so Shopify's spam check can add its token.
    status.hidden = true; send.disabled = true; send.textContent = 'Sending…';
  });
  // If the page is restored from the back/forward cache, make the button usable again.
  window.addEventListener('pageshow', function () { send.disabled = false; send.textContent = 'Send'; });

  // Back from a submit: show Shopify's result, then tidy the address bar.
  var posted = box.querySelector('[data-bnb-posted]');
  var errored = box.querySelector('[data-bnb-errored]');
  if (location.hash === '#BnbCommentForm' && (posted || errored)) {
    box.hidden = false; btn.setAttribute('aria-expanded', 'true');
    if (posted) timer = setTimeout(function () { close(false); }, 4000);
    try {
      var clean = location.pathname + location.search.replace(/([?&])contact_posted=true&?/, '$1').replace(/[?&]$/, '');
      history.replaceState(null, '', clean);
    } catch (err) {}
  }

  btn.hidden = false;
})();
